import React, { ChangeEvent } from "react";
import { Button, Col, Form, Input, Label, Row } from "reactstrap";
import { toast } from "react-toastify";
import { ActiveCallbackProp, ContactsDetailsFormType } from "../../../../../../../types/Forms";
import { ContactDetails, Continue, Email, JoinOrganizationType, OrganizationDescription, OrganizationName, Previous } from "../../../../../../../constants";
import { useForm } from "react-hook-form";

const ContactDetailsForm: React.FC<ActiveCallbackProp> = ({ activeCallBack }) => {
  const { register, formState: { errors }, setValue, watch, handleSubmit,} = useForm({
    defaultValues: { organizationName: "", email: "", description: "", organizationType: "" },
  });

  const formData = watch();
  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    let name = event.target.name as keyof typeof ContactsDetailsFormType;
    let value = event.target.value;
    setValue(name, value, { shouldValidate: true, shouldDirty: true });
  };

  const handleNextButton = handleSubmit(
    () => {
      if (formData.organizationName !== "" && formData.email !== "" && formData.description !== "" && formData.organizationType !== "") activeCallBack(4);
    },
    () => {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  );
  return (
    <Form onSubmit={(event) => event.preventDefault()} className="needs-validation" noValidate>
      <Row className="g-3">
        <Col xs="12">
          <h6>{ContactDetails}</h6>
          <p>{" Please visit the documentation page if you require further information."}</p>
        </Col>
        <Col sm="6">
          <Label>{OrganizationName}<span className="txt-danger">*</span></Label>
          <Input {...register("organizationName", { required: "Organization name is required" })} type="text" placeholder="Gekko & Co." value={formData.organizationName} onChange={updateFormData} />
          {errors.organizationName && <span className='text-danger'>{errors.organizationName.message}</span>}
        </Col>
        <Col sm="6">
          <Label>{Email}<span className="txt-danger">*</span></Label>
          <Input {...register("email", { required: "Email is required" })} type="text" placeholder="org@support.com" value={formData.email} onChange={updateFormData} />
          {errors.email && <span className='text-danger'>{errors.email.message}</span>}
        </Col>
        <Col xs="12">
          <Label>{JoinOrganizationType}<span className="txt-danger">*</span></Label>
          <Input {...register("organizationType", { required: "Organization type is required" })} type="select" value={formData.organizationType} onChange={updateFormData} className="f-w-400 f-14 text-gray">
            <option value="" disabled>{"Join organization type"}</option>
            <option value="1">{"Technology"}</option>
            <option value="2">{"Culture"}</option>
            <option value="3">{"NGO"} </option>
            <option value="3">{"Environment"}</option>
            <option value="3">{"Life cycle"}</option>
          </Input>
          {errors.organizationType && <span className='text-danger'>{errors.organizationType.message}</span>}
        </Col>
        <Col xs="12">
          <Label>{OrganizationDescription}</Label>
          <Input {...register("description", { required: "Description is required" })} type="textarea" value={formData.description} onChange={updateFormData} placeholder="Share your problems and another issues" />
          {errors.description && <span className='text-danger'>{errors.description.message}</span>}
        </Col>
        <Col xs="12" className="text-end">
          <Button color="primary" className="me-2" onClick={() => activeCallBack(2)}>{Previous}</Button>
          <Button color="primary" onClick={handleNextButton}>{Continue}</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ContactDetailsForm;
